"use client"

import type { DropStatus } from "@anaconda/core/drop/types"
import { createContext, useContext } from "react"

interface DropsScopeState {
  size: number
  status?: DropStatus | DropStatus[]
}

const DropsScopeContext = createContext<DropsScopeState | null>(null)

export function useDropsScope() {
  const context = useContext(DropsScopeContext)
  if (!context) {
    throw new Error("useDropsScope must be used within DropsScopeProvider")
  }
  return context
}

interface Props {
  children: React.ReactNode
  state: DropsScopeState
}

export function DropsScopeProvider({ children, state }: Props) {
  return (
    <DropsScopeContext.Provider value={state}>
      {children}
    </DropsScopeContext.Provider>
  )
}
